import { Component } from '@angular/core';
import { AlertController, LoadingController, NavController, NavParams } from 'ionic-angular';
import { Globals } from '../../../../globals';
import { CartaCreateFinishSectionPage } from '../carta-create-finish-section/carta-create-finish-section';
import { CartaServices } from '../../services';
import { TranslateService } from '@ngx-translate/core';
import { CartaListPage } from '../../carta-list/carta-list';
/**
 * Generated class for the MenuPartialDishesSelectPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
    selector: 'page-carta-create-list-details',
    templateUrl: 'carta-create-list-details.html',
})
export class CartaCreateListDetailsPage {

    type: any;
    section_index: any;
    carta_uid: any;
    section_name: string = '';
    section_name_ca: string = '';
    section_name_en: string = '';
    section_name_fr: string = '';
    section_name_it: string = '';
    section_name_de: string = '';
    update_state: boolean = false;
    new_section: boolean = false;
    page_index: any;

    show_alert: boolean = true;

    constructor(public navCtrl: NavController,
        public navParams: NavParams,
        public loadingCtrl: LoadingController,
        public globals: Globals,
        public cartaServices: CartaServices,
        public translate: TranslateService,
        private alertCtrl: AlertController) {

        this.update_state = this.navParams.get('update_state');
        this.type = this.navParams.get('type');
        this.carta_uid = this.navParams.get('carta_uid');
        this.section_index = this.navParams.get('section_index');
        this.page_index = this.navParams.get('page_index');
        this.section_name = this.navParams.get('section_name');
        this.section_name_ca = this.navParams.get('section_name_ca');
        this.section_name_fr = this.navParams.get('section_name_fr');
        this.section_name_en = this.navParams.get('section_name_en');
        this.section_name_it = this.navParams.get('section_name_it');
        this.section_name_de = this.navParams.get('section_name_de');
        if (this.section_name == undefined) {
            this.section_name = '';
        }
        if (this.section_name_ca == undefined) {
            this.section_name_ca = '';
        }
        if (this.section_name_fr == undefined) {
            this.section_name_fr = '';
        }
        if (this.section_name_en == undefined) {
            this.section_name_en = '';
        }
        if (this.section_name_it == undefined) {
            this.section_name_it = '';
        }
        if (this.section_name_de == undefined) {
            this.section_name_de = '';
        }
        this.new_section = this.navParams.get('new_section');

        if (!this.update_state) { //
            var _obj: any;
            if (this.section_index == 0) {
                //Creamos array tmp
                _obj = {
                    0: {
                        name: this.section_name,
                        name_ca: this.section_name_ca,
                        name_en: this.section_name_en,
                        name_it: this.section_name_it,
                        name_fr: this.section_name_fr,
                        name_de: this.section_name_de,
                        order: this.section_index + 1,
                        elements: this.cartaServices.carta_dish_prod_array_tmp,
                    },
                };
                this.cartaServices.carta_section_array_complete_tmp = _obj;

            } else {
                //Si no es la primera seccion creamos solo la nueva seccion
                this.cartaServices.carta_section_array_complete_tmp[this.section_index] = {
                    name: this.section_name,
                    name_ca: this.section_name_ca,
                    name_en: this.section_name_en,
                    name_it: this.section_name_it,
                    name_fr: this.section_name_fr,
                    name_de: this.section_name_de,
                    order: this.section_index + 1,
                    elements: this.cartaServices.carta_dish_prod_array_tmp,
                };
            }

            if (this.page_index == 0) {
                var _page = {
                    0: {
                        number: 1,
                        sections: this.cartaServices.carta_section_array_complete_tmp,
                    },
                };
                this.cartaServices.carta_page_array_complete_tmp = _page;
            } else {
                this.cartaServices.carta_page_array_complete_tmp[this.page_index] = {
                    number: 1,
                    sections: this.cartaServices.carta_section_array_complete_tmp,
                };
            }

        } else {
            if (this.new_section) {
                this.cartaServices.carta_page_array_complete_tmp = this.cartaServices.carta_tmp.pages;

                this.cartaServices.carta_page_array_complete_tmp[this.page_index].sections[this.section_index] = {
                    name: this.section_name,
                    name_ca: this.section_name_ca,
                    name_en: this.section_name_en,
                    name_it: this.section_name_it,
                    name_fr: this.section_name_fr,
                    name_de: this.section_name_de,
                    order: this.section_index + 1,
                    elements: {},
                };

            }
        }
    }

    ionViewCanLeave(): Promise<void> {
        return new Promise((resolve, reject) => {
            //Si el show_alert es true i no estem fen un update al plat
            if (this.show_alert && !this.update_state) {
                let alert = this.alertCtrl.create({
                    title: this.translate.instant('general-atencion'),
                    message: this.translate.instant('general-salir-proceso-creacion'),
                    subTitle: this.translate.instant('general-se-eliminara-elemento'),
                    buttons: [
                        {
                            text: this.translate.instant('general-no'),
                            role: 'cancel',
                            handler: () => {
                                this.globals.side_menu_active = 'stock';
                                reject();
                            },
                        },
                        {
                            text: this.translate.instant('general-si'),
                            handler: () => {
                                this.cartaServices.afs.collection('cartas').doc(this.carta_uid).delete();
                                this.cartaServices.carta_dish_prod_array_tmp = [];
                                resolve();
                                this.navCtrl.setRoot(CartaListPage);
                            },
                        },
                    ],
                });
                alert.present();
            } else {
                resolve();
            }
        });
    }


    updateSection() {
        this.show_alert = false;
        //Preparamos el objecto para insertarlo en los dish del menu
        var _obj = {};
        for (var i = 0; this.cartaServices.carta_dish_prod_array_tmp.length > i; i++) {


            if (this.cartaServices.carta_dish_prod_array_tmp[i][15] == undefined) {
                this.cartaServices.carta_dish_prod_array_tmp[i][15] = '';
            }
            if (this.cartaServices.carta_dish_prod_array_tmp[i][16] == undefined) {
                this.cartaServices.carta_dish_prod_array_tmp[i][16] = '';
            }
            if (this.cartaServices.carta_dish_prod_array_tmp[i][17] == undefined) {
                this.cartaServices.carta_dish_prod_array_tmp[i][17] = '';
            }
            if (this.cartaServices.carta_dish_prod_array_tmp[i][18] == undefined) {
                this.cartaServices.carta_dish_prod_array_tmp[i][18] = '';
            }
            if (this.cartaServices.carta_dish_prod_array_tmp[i][19] == undefined) {
                this.cartaServices.carta_dish_prod_array_tmp[i][19] = '';
            }
            if (this.cartaServices.carta_dish_prod_array_tmp[i][20] == undefined) {
                this.cartaServices.carta_dish_prod_array_tmp[i][20] = '';
            }

            if (this.cartaServices.carta_dish_prod_array_tmp[i][9] == undefined) {
                this.cartaServices.carta_dish_prod_array_tmp[i][9] = [];
            }
            if (this.cartaServices.carta_dish_prod_array_tmp[i][21] == undefined) {
                this.cartaServices.carta_dish_prod_array_tmp[i][21] = [];
            }
            if (this.cartaServices.carta_dish_prod_array_tmp[i][25] == undefined) {
                this.cartaServices.carta_dish_prod_array_tmp[i][25] = '';
            }

            _obj[i] = {
                uid: this.cartaServices.carta_dish_prod_array_tmp[i][0],
                order: i + 1,
                type: this.cartaServices.carta_dish_prod_array_tmp[i][2],
                name_es: this.cartaServices.carta_dish_prod_array_tmp[i][3],
                name_ca: this.cartaServices.carta_dish_prod_array_tmp[i][4],
                name_en: this.cartaServices.carta_dish_prod_array_tmp[i][5],
                name_de: this.cartaServices.carta_dish_prod_array_tmp[i][6],
                name_fr: this.cartaServices.carta_dish_prod_array_tmp[i][7],
                name_it: this.cartaServices.carta_dish_prod_array_tmp[i][8],
                allergens: this.cartaServices.carta_dish_prod_array_tmp[i][9],
                price: this.cartaServices.carta_dish_prod_array_tmp[i][10],
                price_half: this.cartaServices.carta_dish_prod_array_tmp[i][11],
                price_tapa: this.cartaServices.carta_dish_prod_array_tmp[i][12],
                cost_ration: this.cartaServices.carta_dish_prod_array_tmp[i][13],
                image: this.cartaServices.carta_dish_prod_array_tmp[i][14],
                description_es: this.cartaServices.carta_dish_prod_array_tmp[i][15],
                description_ca: this.cartaServices.carta_dish_prod_array_tmp[i][16],
                description_en: this.cartaServices.carta_dish_prod_array_tmp[i][17],
                description_de: this.cartaServices.carta_dish_prod_array_tmp[i][18],
                description_fr: this.cartaServices.carta_dish_prod_array_tmp[i][19],
                description_it: this.cartaServices.carta_dish_prod_array_tmp[i][20],
                tags: this.cartaServices.carta_dish_prod_array_tmp[i][21],
                price_takeaway: this.cartaServices.carta_dish_prod_array_tmp[i][22],
                tk_active: this.cartaServices.carta_dish_prod_array_tmp[i][23],
                featured: this.cartaServices.carta_dish_prod_array_tmp[i][24],
                tk_pickup_day: this.cartaServices.carta_dish_prod_array_tmp[i][25],
                tax: this.cartaServices.carta_dish_prod_array_tmp[i][26],
            };
        }

        if (this.update_state) {

            if (this.new_section) {
                this.cartaServices.carta_tmp.pages[this.page_index].sections[this.section_index].name = this.section_name;
                this.cartaServices.carta_tmp.pages[this.page_index].sections[this.section_index].name_ca = this.section_name_ca;
                this.cartaServices.carta_tmp.pages[this.page_index].sections[this.section_index].name_en = this.section_name_en;
                this.cartaServices.carta_tmp.pages[this.page_index].sections[this.section_index].name_fr = this.section_name_fr;
                this.cartaServices.carta_tmp.pages[this.page_index].sections[this.section_index].name_it = this.section_name_it;
                this.cartaServices.carta_tmp.pages[this.page_index].sections[this.section_index].name_de = this.section_name_de;
                this.cartaServices.carta_tmp.pages[this.page_index].sections[this.section_index].elements = _obj;
            } else {
                this.cartaServices.carta_tmp.pages[this.cartaServices.edit_page_index].sections[this.cartaServices.edit_index].name = this.section_name;
                this.cartaServices.carta_tmp.pages[this.cartaServices.edit_page_index].sections[this.cartaServices.edit_index].name_ca = this.section_name_ca;
                this.cartaServices.carta_tmp.pages[this.cartaServices.edit_page_index].sections[this.cartaServices.edit_index].name_en = this.section_name_en;
                this.cartaServices.carta_tmp.pages[this.cartaServices.edit_page_index].sections[this.cartaServices.edit_index].name_fr = this.section_name_fr;
                this.cartaServices.carta_tmp.pages[this.cartaServices.edit_page_index].sections[this.cartaServices.edit_index].name_it = this.section_name_it;
                this.cartaServices.carta_tmp.pages[this.cartaServices.edit_page_index].sections[this.cartaServices.edit_index].name_de = this.section_name_de;
                this.cartaServices.carta_tmp.pages[this.cartaServices.edit_page_index].sections[this.cartaServices.edit_index].elements = _obj;
            }
        } else {
            this.cartaServices.carta_page_array_complete_tmp[this.page_index].sections[this.section_index].elements = _obj;
        }


        this.cartaServices.carta_dish_prod_array_tmp = Array(); //Limpiamos el array
    }


    openFinish() {
        this.globals.GAtrackView('Cartas', 'Cartas - Select elements - Create', this.globals.restaurant.email, 'Create/Update', 'Create select elements', 'Cartas', this.carta_uid);

        this.updateSection();
        this.cartaServices.afs.collection('cartas').doc(this.carta_uid).update({
            'pages': this.cartaServices.carta_page_array_complete_tmp,
            'updated_at': new Date(),
        }).then(() => {
            this.navCtrl.push(CartaCreateFinishSectionPage, {
                update_state: false,
                type: this.type,
                carta_uid: this.carta_uid,
                section_index: this.section_index,
                section_name: this.section_name,
                page_index: this.page_index,
            });
        });


    }

    updateAndReturn() {
        this.globals.GAtrackView('Cartas', 'Cartas - Select elements - Update', this.globals.restaurant.email, 'Create/Update', 'Update select elements', 'Cartas', this.carta_uid);
        this.updateSection();

        this.cartaServices.afs.collection('cartas').doc(this.carta_uid).update({
            'pages': this.cartaServices.carta_tmp.pages,
        }).then(() => {
            this.navCtrl.pop();
            this.navCtrl.pop();
        });

    }

}


// WEBPACK FOOTER //
// ./src/pages/carta/carta-create/carta-create-list-details/carta-create-list-details.ts